import { add } from "date-fns";
import { get } from "react-hook-form";
import { BASE_URL } from "utils/constant";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("access")}`,
  "Content-Type": "application/json",
});

const getApiErrorMessage = (data, fallback) => {
  if (Array.isArray(data?.non_field_errors) && data.non_field_errors[0]) {
    return data.non_field_errors[0];
  }

  if (Array.isArray(data?.detail) && data.detail[0]) {
    return data.detail[0];
  }

  if (typeof data?.detail === "string") {
    return data.detail;
  }

  if (typeof data?.message === "string") {
    return data.message;
  }

  if (data && typeof data === "object") {
    const firstFieldError = Object.values(data)
      .flat()
      .find((value) => typeof value === "string");

    if (firstFieldError) {
      return firstFieldError;
    }
  }

  return fallback;
};

export const taskApi = {
  // get all task groups
  // response format
  // {
  //   "status": true,
  //   "message": "Task Groups retrieved successfully",
  //   "data": [
  //       {
  //           "id": 1,
  //           "group_name": "Stage 2 | prototype",
  //           "status": "Active",
  //           "start_date": "2025-07-21",
  //           "end_date": "2025-10-07",
  //           "priority": 3,
  //           "created_by": "Apratim",
  //           "created_on": "2025-05-16T00:44:39.451095+05:30",
  //           "last_updated_by": "duttaapratim11@gmail.com",
  //           "last_updated_on": "2025-08-15T12:51:09.477402+05:30",
  //           "section": null,
  //           "site": 42,
  //           "allocated_members": [
  //               {
  //                   "member_id": 376,
  //                   "first_name": "Individual",
  //                   "last_name": "Apratim",
  //                   "userpic": null
  //               },
  //               {
  //                   "member_id": 202,
  //                   "first_name": "Apratim",
  //                   "last_name": "Dutta",
  //                   "userpic": "https://sitemasterstorageaccount.blob.core.windows.net/sm-user-uploades/user_pics/4/image_2.png?se=2025-08-15T07%3A35%3A42Z&sp=r&sv=2024-11-04&sr=b&skoid=151ee12f-04ce-46f8-884e-4360b966b07b&sktid=579953b3-fb9c-42a0-bc13-0fabda32419f&skt=2025-08-09T08%3A42%3A10Z&ske=2025-08-16T08%3A42%3A10Z&sks=b&skv=2024-11-04&sig=vZHp/Ff2Hu5vbbViBbsuM2Il8iTllufDceWHVRpWz/I%3D"
  //               },
  //               {
  //                   "member_id": 334,
  //                   "first_name": "Anurag",
  //                   "last_name": "Bose",
  //                   "userpic": null
  //               },
  //               {
  //                   "member_id": 367,
  //                   "first_name": "Shashwat",
  //                   "last_name": "Talukdar",
  //                   "userpic": null
  //               }
  //           ],
  //           "task_group_summary": {
  //               "total_tasks": 3,
  //               "completed_tasks": 1,
  //               "overdue_tasks": 0,
  //               "ongoing_tasks": 2,
  //               "not_started_tasks": 0,
  //               "high_priority": 1,
  //               "medium_priority": 2,
  //               "low_priority": 0
  //           }
  //       }
  //     ]
  //   }

  getAllTaskGroups: async () => {
    const site = Number(localStorage.getItem("site"));
    const res = await fetch(
      `${BASE_URL}/task/get-all-task-groups/?site_id=${site}`,
      {
        method: "GET",
        headers: getAuthHeaders(),
      }
    );
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data.data;
  },

  getAllTaskGroupsBySite: async (siteId) => {
    const site =
      typeof siteId === "number" || typeof siteId === "string"
        ? siteId
        : Number(localStorage.getItem("site"));
    const res = await fetch(
      `${BASE_URL}/task/get-all-task-groups/?site_id=${site}`,
      {
        method: "GET",
        headers: getAuthHeaders(),
      }
    );
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data.data;
  },

  // get all tasks
  // response format
  // {
  //   "status": true,
  //   "message": "Tasks retrieved successfully.",
  //   "data": [
  //       {
  //           "id": 141,
  //           "created_by": "Apratim",
  //           "last_updated_by": "Apratim",
  //           "task_members": [
  //               {
  //                   "taskmember_id": 376,
  //                   "member_id": 202
  //               },
  //               {
  //                   "taskmember_id": 378,
  //                   "member_id": 334
  //               },
  //               {
  //                   "taskmember_id": 464,
  //                   "member_id": 376
  //               },
  //               {
  //                   "taskmember_id": 466,
  //                   "member_id": 367
  //               }
  //           ],
  //           "task_name": "Avengers assemble",
  //           "task_status": "Complete",
  //           "task_details": "–",
  //           "priority": 3,
  //           "start_date": "2025-06-02",
  //           "end_date": "2025-06-02",
  //           "estimated_amount": 0.0,
  //           "created_on": "2025-06-03T02:02:39.854374+05:30",
  //           "last_updated_on": "2025-08-15T12:57:58.281851+05:30",
  //           "task_group": 1,
  //           "allocated_members": [
  //               {
  //                   "member_id": 202,
  //                   "first_name": "Apratim",
  //                   "last_name": "Dutta"
  //               },
  //               {
  //                   "member_id": 334,
  //                   "first_name": "Anurag",
  //                   "last_name": "Bose"
  //               },
  //               {
  //                   "member_id": 376,
  //                   "first_name": "Individual",
  //                   "last_name": "Apratim"
  //               },
  //               {
  //                   "member_id": 367,
  //                   "first_name": "Shashwat",
  //                   "last_name": "Talukdar"
  //               }
  //           ]
  //       }
  //     ]
  // }

  getAllTasks: async (task_group) => {
    const res = await fetch(`${BASE_URL}/task/get-all-tasks/`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({ task_group }),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data.data;
  },

  // response format
  // {
  //   "status": true,
  //   "message": "Subtasks retrieved successfully.",
  //   "data": [
  //       {
  //           "id": 455,
  //           "subtask_name": "Final Electrical & Plumbing Fixtures",
  //           "is_completed": false,
  //           "subtask_details": "–",
  //           "start_date": "2025-07-17",
  //           "end_date": "2025-07-28",
  //           "created_by": "Apratim Dutta",
  //           "task_id": 118,
  //           "assign_to": []
  //       }
  //     ]
  //   };

  getAllSubtasks: async (taskId) => {
    const res = await fetch(`${BASE_URL}/task/get-all-subtasks/`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({ task_id: taskId }),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data.data;
  },

  //payload structure
  //   {
  //     "site_id": 42,
  //     "task_group_name": "Gannt View",
  //     "status": "Active",
  //     "start_date": "2025-08-15",
  //     "end_date": "2025-08-31",
  //     "priority": 3
  // }
  addTaskGroup: async (payload) => {
    const res = await fetch(`${BASE_URL}/task/create-task-group/`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  },

  // payload structure
  //   {
  //     "task_group": 1,
  //     "task_name": "task pilining",
  //     "task_details": "–", // may be blank
  //     "task_status": "Not Started", //default
  //     "start_date": "2025-08-15",
  //     "end_date": "2025-08-15",
  //     "priority": 2,
  //     "estimated_amount": "0" // may be blank
  // }
  addTask: async (payload) => {
    const res = await fetch(`${BASE_URL}/task/create-tasks/`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  },

  //payload structure
  // {
  //     "task_id": 498,
  //     "subtask_name": "sub1",
  //     "subtask_details": "–", // may be blank
  //     "end_date": "2025-08-15",
  //     "priority": 2,
  //     "assign_to": [] //keep empty array
  // }

  addSubtask: async (payload) => {
    const res = await fetch(`${BASE_URL}/task/create-subtasks/`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data.data;
  },
  deleteTaskGroup: async (groupId) => {
    const res = await fetch(`${BASE_URL}/task/taskgroup/delete/${groupId}/`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  },

  deleteTask: async (taskId) => {
    const res = await fetch(`${BASE_URL}/task/delete-task/${taskId}/`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  },

  deleteSubtask: async (subtaskId) => {
    const res = await fetch(`${BASE_URL}/task/delete-subtask/${subtaskId}/`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data.data;
  },

  updateTaskGroup: async (groupId, updates) => {
    const res = await fetch(`${BASE_URL}/task/task-group/${groupId}/update/`, {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify(updates),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  },

  updateTask: async (taskId, updates) => {
    const res = await fetch(`${BASE_URL}/task/update-task/${taskId}/`, {
      method: "PATCH",
      headers: getAuthHeaders(),
      body: JSON.stringify(updates),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  },

  updateSubtask: async (subtaskId, updates) => {
    const res = await fetch(`${BASE_URL}/task/update-subtask/${subtaskId}/`, {
      method: "PATCH",
      headers: getAuthHeaders(),
      body: JSON.stringify(updates),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    const data = await res.json();
    return data.data;
  },

  createTaskDependency: async (payload) => {
    const res = await fetch(`${BASE_URL}/task/task-dependencies/`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) {
      const message =
        data?.non_field_errors?.[0] ||
        data?.message ||
        `HTTP error! Status: ${res.status}`;
      throw new Error(message);
    }
    return data.data;
  },

  getTaskDependencies: async (taskId) => {
    const res = await fetch(
      `${BASE_URL}/task/task-dependencies/?task_id=${taskId}`,
      {
        method: "GET",
        headers: getAuthHeaders(),
      }
    );
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data?.message || `HTTP error! Status: ${res.status}`);
    }
    return data.data;
  },

  updateTaskDependency: async (dependencyId, payload) => {
    const res = await fetch(
      `${BASE_URL}/task/task-dependencies/${dependencyId}/`,
      {
        method: "PATCH",
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      }
    );
    const data = await res.json();
    if (!res.ok) {
      throw new Error(
        getApiErrorMessage(data, `HTTP error! Status: ${res.status}`),
      );
    }
    return data.data || data;
  },

  deleteTaskDependency: async (dependencyId) => {
    const res = await fetch(
      `${BASE_URL}/task/task-dependencies/${dependencyId}/`,
      {
        method: "DELETE",
        headers: getAuthHeaders(),
      }
    );
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data?.message || `HTTP error! Status: ${res.status}`);
    }
    return data;
  },

  // Task Approvers
  assignTaskApprovers: async (taskId, approverIds) => {
    const res = await fetch(
      `${BASE_URL}/task/tasks/${taskId}/assign-approvers/`,
      {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ approver_ids: approverIds }),
      }
    );
    return await res.json();
  },

  // Task Updates
  getAllUpdatesByOrg: async (orgId, siteId) => {
    const organizationId =
      orgId ??
      JSON.parse(localStorage.getItem("organization") || "{}")?.id;
    const site =
      siteId !== undefined && siteId !== null
        ? siteId
        : Number(localStorage.getItem("site"));

    if (!organizationId) {
      throw new Error("Organization not found in local storage.");
    }

    const params = new URLSearchParams();
    if (site) {
      params.set("site", String(site));
    }

    const query = params.toString() ? `?${params.toString()}` : "";
    const res = await fetch(
      `${BASE_URL}/task/tasks/${organizationId}/all-updates/${query}`,
      {
        method: "GET",
        headers: getAuthHeaders(),
      },
    );
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const data = await res.json();
    return (
      (Array.isArray(data) && data) ||
      data?.Data ||
      data?.data ||
      data?.results ||
      []
    );
  },

  getTasksBySite: async (siteId) => {
    const site =
      siteId !== undefined && siteId !== null
        ? siteId
        : Number(localStorage.getItem("site"));

    if (!site) {
      throw new Error("Site not found in local storage.");
    }

    const res = await fetch(`${BASE_URL}/task/tasks-by-site/${site}/`, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const data = await res.json();
    return (
      (Array.isArray(data) && data) ||
      data?.Data ||
      data?.data ||
      data?.results ||
      []
    );
  },

  createTaskUpdate: async (taskId, comment) => {
    const res = await fetch(`${BASE_URL}/task/tasks/${taskId}/updates/create/`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({ comment }),
    });
    return await res.json();
  },

  listTaskUpdates: async (taskId) => {
    const res = await fetch(
      `${BASE_URL}/task/tasks/${taskId}/updates/create/`,
      {
        headers: getAuthHeaders(),
      }
    );
    return await res.json();
  },

  deleteTaskUpdate: async (updateId) => {
    const res = await fetch(
      `${BASE_URL}/task/tasks/updates/${updateId}/delete/`,
      {
        method: "DELETE",
        headers: getAuthHeaders(),
      }
    );
    return await res.json();
  },

  // Subtask Updates
  createSubtaskUpdate: async (subtaskId, comment, file = null) => {
    const formData = new FormData();
    formData.append("comment", comment);
    if (file) formData.append("file", file);

    const headers = getAuthHeaders();
    delete headers["Content-Type"]; // Let browser set content type for FormData

    const res = await fetch(
      `${BASE_URL}/task/subtasks/${subtaskId}/updates/create/`,
      {
        method: "POST",
        headers,
        body: formData,
      }
    );
    return await res.json();
  },

  listSubtaskUpdates: async (subtaskId) => {
    const res = await fetch(`${BASE_URL}/task/subtasks/${subtaskId}/updates/`, {
      headers: getAuthHeaders(),
    });
    return await res.json();
  },

  deleteSubtaskUpdate: async (updateId) => {
    const res = await fetch(
      `${BASE_URL}/task/subtasks/updates/${updateId}/delete/`,
      {
        method: "DELETE",
        headers: getAuthHeaders(),
      }
    );
    return await res.json();
  },

  // Approval Flow
  requestSubtaskUpdateApproval: async (updateId, comment, file = null) => {
    const formData = new FormData();
    formData.append("comment", comment);
    if (file) formData.append("file", file);

    const headers = getAuthHeaders();
    delete headers["Content-Type"]; // Let browser set content type for FormData

    const res = await fetch(
      `${BASE_URL}/task/subtasks/updates/${updateId}/request-approval/`,
      {
        method: "POST",
        headers,
        body: formData,
      }
    );
    return await res.json();
  },

  approveRejectSubtaskUpdate: async (updateId, action, comment = "") => {
    const res = await fetch(
      `${BASE_URL}/task/subtasks/updates/${updateId}/approve-reject/`,
      {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          action,
          comment,
        }),
      }
    );
    return await res.json();
  },

  getTaskMembers: async (taskId) => {
    try {
      const headers = getAuthHeaders();
      const response = await fetch(`${BASE_URL}/task/get-task-members/`, {
        method: "POST",
        headers,
        body: JSON.stringify({ task_id: taskId }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching task members:", error);
      throw error;
    }
  },

  addTaskMembers: async (data) => {
    try {
      const headers = getAuthHeaders();
      // console.log("Adding task members with data:", data);
      const response = await fetch(`${BASE_URL}/task/create-task-members/`, {
        method: "POST",
        headers,
        body: JSON.stringify(data),
      });

      // console.log("Response from adding task members:", response);
      // if (!response.ok) {
      //   throw new Error(`HTTP error! Status: ${response.status}`);
      // }

      return response;
    } catch (error) {
      console.error("Error adding task members:", error);
      throw error;
    }
  },

  removeTaskMember: async (memberId) => {
    try {
      const headers = getAuthHeaders();
      const response = await fetch(
        `${BASE_URL}/task/delete-task-member/${memberId}/`,
        {
          method: "DELETE",
          headers,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error removing task member:", error);
      throw error;
    }
  },

  getSiteMembers: async (siteId) => {
    // console.log("Fetching site members for siteId:", siteId);
    const response = await fetch(
      `${BASE_URL}/team/list-site-members/${siteId}/`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  },

  updateTask: async (taskId, taskData) => {
    const headers = getAuthHeaders();
    const response = await fetch(`${BASE_URL}/task/update-task/${taskId}/`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(taskData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        getApiErrorMessage(data, `HTTP error! Status: ${response.status}`),
      );
    }

    return data;
  },

  updateSubtask: async (subtaskId, subtaskData) => {
    const headers = getAuthHeaders();
    const response = await fetch(
      `${BASE_URL}/task/update-subtask/${subtaskId}/`,
      {
        method: "PATCH",
        headers,
        body: JSON.stringify(subtaskData),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        getApiErrorMessage(data, `HTTP error! Status: ${response.status}`),
      );
    }

    return data;
  },

  getTaskReport: async (siteId) => {
    const res = await fetch(`${BASE_URL}/task/task-report/${siteId}/`, {
      method: "GET",
      headers: getAuthHeaders(),
    });
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    return await res.json();
  },

  deleteTaskDocument: async (documentId) => {
    const response = await fetch(
      `${BASE_URL}/task/delete-document/${documentId}/`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      }
    );

    if (!response.ok) {
      let errorMessage = `HTTP error! Status: ${response.status}`;
      try {
        const errorData = await response.json();
        errorMessage =
          errorData?.detail || errorData?.message || errorMessage;
      } catch {
        /* ignore */
      }
      throw new Error(errorMessage);
    }

    if (response.status === 204) {
      return null;
    }

    try {
      return await response.json();
    } catch {
      return null;
    }
  },
};
